// extracted by mini-css-extract-plugin
export default {"featureDescriptionTrigger":"f00adfd3f6e0","featureFlagsTable":"d11ecaa77969","mobileFeatureList":"edbdd26459c5"};